import type { SymbolicatedFrame } from "@backstory/protocol";

/** Shared stack renderer for JS-error issues and legacy error links. */
export function FrameList({ frames }: { frames: SymbolicatedFrame[] }) {
  return (
    <div className="ins-stack" role="list" aria-label="Stack frames">
      {frames.map((f, i) => (
        <div key={i} className={`frame ${f.inApp ? "in-app" : ""}`} role="listitem" data-testid="frame">
          <span className="fn">{f.originalFunction ?? f.function ?? "<anonymous>"}</span>{" "}
          <span className="loc">
            {f.originalFile ?? f.file ?? "?"}:{f.originalLine ?? f.line ?? "?"}
            {(f.originalColumn ?? f.column) !== undefined ? `:${f.originalColumn ?? f.column}` : ""}
            {f.originalFile && f.file && f.originalFile !== f.file ? <span className="muted"> (from {f.file}:{f.line})</span> : null}
          </span>
          {f.context && (
            <pre className="ctx">
              {f.context.pre.map((line) => `${line}\n`).join("")}
              <span className="cur">{f.context.line}</span>
              {f.context.post.map((line) => `\n${line}`).join("")}
            </pre>
          )}
        </div>
      ))}
    </div>
  );
}
